import containsAtLeastOneNotSavedEstimation from './containsAtLeastOneNotSavedEstimation';
import NotificationProduced from '../../application/core/events/NotificationProduced';
import EstimationsDraftSaveRequested from '../../application/estimations/events/EstimationsDraftSaveRequested';
import * as uniqid from 'uniqid';
import State from '../../application/core/State';
import Event from '../../application/core/Event';
import Notification from '../../application/core/Notification';

export default (state: State, event: EstimationsDraftSaveRequested): Event[] =>
    containsAtLeastOneNotSavedEstimation(state.estimations.estimations, state.estimations.placedEstimations)
        ? [event]
        : [
              new NotificationProduced(
                  new Notification(uniqid(), {
                      message: 'Please, provide/update quantity for at least one item before saving draft.',
                      hasButton: true
                  })
              )
          ];



// WEBPACK FOOTER //
// ./src/domain/estimations/validateSavingEstimationDraft.ts